<template>
  <div class="layout-header" :class="{shadow: elTop >= 50 && hideSearch}">

    <div class="pc">
      <div class="left">
        <a href='/' class="website-name pc">HG Solution</a
        ><input @input="searchFilter" v-model="keyword" type="text" placeholder="Search item"/>
      </div>
      <div class="right">
        <p class="contactUs" @click="contactUS()">Contact Us</p
        ><div class="user">
          <template v-if="token != null && userinfo !=null">
            <div @click="showUser">
              <Icon class="user-icon" :fill="'#fff'" :width="'25px'" :height="'25px'" :name="'user'"/><p class="username">{{userinfo.name || userinfo.phone}}</p>
            </div>
          </template>
          <p class="login" @click="login" v-else>Login</p>
        </div>
      </div>
    </div>

    <!-- ────[Mobile]─────────────────────────────────────────────────── -->
    <div class="mobile">
      <div class="mcontainer">
        <div class="left">
          <div class="menu" @click="sidemenu = !sidemenu">
            <Icon :fill="'#353F43'" :width="'22px'" :height="'22px'" :name="'menu'"/>
          </div>
          <p class="title">{{homeTitle}}</p>
        </div>
        <div class="right">
          <div class="icon" @click="openCart">
            <Icon :fill="'#353F43'" :width="'22px'" :height="'22px'" :name="'cart'"/>
          </div>
          <div class="icon" @click="showAlphabet = true">
            <Icon :fill="'#353F43'" :width="'22px'" :height="'22px'" :name="'abc'"/>
          </div>
        </div>
      </div>
      <div class="searchbar" :class="{hide: hideSearch, shadow: elTop >= 100}">
        <input type="text" @input="searchFilter" v-model="keyword" placeholder="Search item">
      </div>

      <side-menu class="smenu" :class="{smActive:sidemenu}" @close="sidemenu = false"/>
      <alphabet-filter class="abc" :class="{abctive:showAlphabet}" @close="showAlphabet = false"/>
      <div class="overlay" v-if="showAlphabet || sidemenu" @click="close"></div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import {GetProductList} from '@/api/index.js'
import AlphabetFilter from '@/components/AlphabetFilter'
import SideMenu from '@/components/SideMenu'
import Icon from '@/components/Reusables/Icon'
export default {
  name: 'LayoutHeader',
  data() {
    return {
      currentMenu:'All',
      userinfo:null,
      token:null,
      cid:null,
      bid: null,
      curpage:1,
      loading: false,
      category: null,
      currItem: -1,
      keyword:'',
      brandList:null,

      // showMore:false,
      showAlphabet:false,
      showCat:false,
      showDrop: false,
      sidemenu: false,

      debounce: null,
      hideSearch: false,
    };
  },
  props:{
    cName:{
      default:null
    },
    selLetter:{
      default:null
    }
  },
  computed:{
    ...mapGetters('user',['getUserInfo','getToken']),
    searchKeyword(){
      return this.$store.state.product.keyword
    },
    elTop(){
      return this.$store.state.elTop
    },
    brandid(){
        return this.$store.state.product.bid
    },
    homeTitle(){
        if(this.brandid == '132'){
            return 'Mining Accessories'
        } else if(this.brandid == '133'){
            return 'RFID'
        } else{
            return 'Network Equipment'
        }
    }
  },
  components: {
    AlphabetFilter,
    SideMenu,
    Icon,
  },
  created(){
    if(window.location.pathname == '/contactUs'){
      this.currItem = -2;
    }
  },
  mounted(){
    this.userinfo = this.$store.getters['user/getUserInfo'];
    this.token = this.$store.getters['user/getToken'];
  },
  methods: {
    openCart(){
      if(this.$store.getters["user/getUserInfo"] && this.$store.getters["user/getToken"]){
        this.$router.push('/network/shoppingcart');
      } else{
        this.$store.commit('setCred', 'login');
      }
    },
    goTo(page){
      this.$router.push(`/${page}`)
    },
    close(){
      this.showAlphabet = false
      this.sidemenu = false
      console.log(this.sidemenu)
    },
    login(){
      this.$store.commit('setCred', 'login')
    },





    showAlph(){
      this.$emit('alph');
      console.log('triggered!!!!!!!!')
    },
    selectAlph(bid, cid, cname, letter){
      console.log(letter);
      this.$parent.menuFilter(bid, cid, cname, letter);
      // this.$emit('close');
    },
    contactUS(){
      this.$router.push({path:'/network/contactUs'});
      this.currItem = -2;
    },
    showMore(){
      this.$emit('more');
    },
    mobMenuFilter(index,id,name){
      this.menuFilter(index, id);
      this.currentMenu = name;
      this.showCat = false;
    },
    menuFilter: function(index, bid){
      // this.showMore = false;
      localStorage.setItem('currItem', -1);
      localStorage.setItem('currAlph', '-');
      this.currItem = index;
      // localStorage.setItem('currItem', null);
      this.$parent.menuFilter(bid, null)
    },
    smFilter(bid,cid){
      this.$parent.menuFilter(bid,cid);
    },
    searchFilter(){
      if(this.$route.name != 'home'){
          this.$router.push('/network')
      }
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.$store.commit('product/setKeyword', this.keyword)
      }, 600);
    },
    showUser(){
      this.$store.commit('setEditUser', true);
      // this.$emit('showUser');
    },
  },
  watch:{
    searchKeyword(newVal, oldVal){
      console.log(newVal, oldVal)
    },
    elTop(newVal, oldVal){
      if(newVal == 0){
        this.hideSearch = false
        return
      }
      // console.log(newVal)
      if(newVal > oldVal){
        this.hideSearch = true
      } else{
        this.hideSearch = false
      }
    }
  }
};
</script>

<style lang="" scoped>

.layout-header{
  width: 100%;
  background: #353F43;
  position: fixed;
  top:0;
  left:0;
  z-index: 100;
  height: 50px;
  text-align: left;
}

.left, .right{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.left{
  left:0;
  width: 65%;
}

.right{
  right: 0;
  width: 45%;
  /* background: red; */
}

.website-name, input {
  display: inline-block;
  vertical-align: middle;
}

.website-name{
  text-decoration: none;
  font-weight: bold;
  font-size: 25px;  
  color:#eee;
  width: 300px;
  text-align: center;
  /* background: lawngreen; */
}

/* SEARCHBAR */
input{
  width: calc(100% - 24px - 300px);
  min-width: 90px;
  border-radius: 8px;
  border-style: none;
  background: #eee;
  padding:5px 12px;
  line-height: 26px;
  font-size: 18px;
}
input:focus{
  outline:none;
}

.contactUs, .user{
  display: inline-block;
  vertical-align: middle;
}

.contactUs{
  color: #fff;
  width: calc(100% - 300px);
  text-align: right;
}
.user{
  width: 300px;
  position: relative;
  /* background: coral; */
  text-align: center;
}
.user:hover, .contactUs:hover{
  opacity: .8;
  cursor: pointer;
}

.user-icon, .username{
  display: inline-block;
  vertical-align: middle;
}
.user-icon{
  margin-right: 10px;
}
.username, .login{
  color: #fff;
}
/*-------------------------------------- CATEGORIES */

.categories{
  background:#fff;
  border-radius: 8px;
  text-align: center;
  width: 150px;
  padding: 10px 0;
  position: absolute;
  top:25px;
  left:50%;
  right: 50%;
  transform: translateX(-50%);
  box-shadow: 0 5px 6px rgba(0,0,0,0.16);
}

ul{
  list-style-type: none;
  padding:0;
}
ul li{
  font-size: 14px;
  font-weight: bold;
  color: #353F43;
  letter-spacing: 1px;
  line-height: 35px;
  /* --- */
  display: block;
  padding: 0 8px;
}
li:first-child{
  margin-left: 0;
}
ul li a{
  text-decoration: none;
  color:#719192;
}
ul li:hover{
  cursor: pointer;
  text-decoration: underline;
  color:#47666F;
}


/*------------------------------------- HEADERTOOL */



/* HEADERTOOL: FILTER MENUS */
.filterbox{
  margin-right: 4%;
  display:inline-block;
  vertical-align: middle;
  position: relative;
}
.filterbox p{
  color:#fff;
  font-size: 15px;
  font-weight: bold;
  display: inline-block;
}.filterbox p:hover{
  cursor: pointer;
  color:#4D9AB0;
}




.alph-wrapper{
  position: relative;
  display: inline-block;
}
/* END OF HEADERTOOL: FILTERMENU */

.dropdown{
  text-decoration: none;
  display: inline-block;
  
  position: relative;
  /* --- */
  /* display:inline-block; */
  /* vertical-align: middle; */
}
.dropdown p, .dropdown a{
  font-size: 14px;
  border-radius: 25px;
  background: #47666F;
  color:#eee;
  padding:5px 12px;
  text-decoration: none;
} .dropdown p:hover, .dropdown a:hover{
  cursor: pointer;
  background: #719192;
}

.userMenu{
  position: absolute;
  width:150px;
  top:35px;
  left:50%;
  transform: translateX(-50%);
  background: #C4CCCE;
  border-radius: 8px;
  z-index: 101;
  overflow: hidden;
}


/*----------------------------------------------------- TRANSITIONS */

.alphtrans-enter-active, .alphtrans-enter-active{
  transition: opacity 0.2s ease-in-out, height 0.3s ease-in-out;
}
.alphtrans-enter, .alphtrans-leave-to{
  opacity: 0;
  height: 0px;
}
.alphtrans-enter-to, .alphtrans-leave{
  opacity:1;
  height: 500px;
}

.smenu{
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(-300px);
  transition: 0.2s ease-in-out;
  z-index: 4;
}

.abc{
  opacity: 1;
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(50px);
  transition: 0.2s ease-in-out;
  z-index: 4;
}

.smActive, .abctive{
  opacity: 1;
  transform: none;
  transition: 0.2s ease-in-out;
}

.overlay{
  position: absolute;
  width: 100%;
  height: 100vh;
  z-index: 3;
  background: rgba(0, 0, 0, 0.212);
}


/* ------------------------------- */

/* .categories-mobile, .mobile{
  display:none;
} */

/*-------------------------------- RESPONSIVES */
@media screen and (min-width:901px){
  .categories-mobile, .mobile{
    display:none;
  }
}
@media screen and (max-width:1100px){
  .website-name{
    margin-right:40px;
  }
  input[type="text"]{
    width:28%;
    margin-right: 40px;
  }
}

@media screen and (max-width:900px){
  .pc{
    display:none!important;
  }
  .layout-header{
    padding:0;
    /* background: none; */
    width: 100%;
  }
  .searchbar{
    background: #eee;
    position: fixed;
    top: 50px;
    width: 100%;
    height: 50px;
    z-index: 1;
    transition: .3s ease-in-out;
  }
  .mcontainer{
    background: #eee;
    height: 50px;
    position: absolute;
    left: 0;
    z-index: 2;
    /* top:50%; */
    /* transform: translateY(-50%); */

    width: 100%;
  }
  .mcontainer .left{
    position: absolute;
    left: 10px;
    width: calc(100% - 80px - 20px);
    /* background: red; */
  }
  .mcontainer .right{
    position: absolute;
    width: 80px;
    right: 10px;
    /* background: blue; */
    text-align: right;
  }
  .menu, .title{
    display: inline-block;
    vertical-align: middle;
  }
  .menu{
    /* background: lemonchiffon; */
  }
  .title{
    font-size: 20px;
    font-weight: bold;
    margin-left: 10px;
  }
  .icon{
    width: 30px;
    height: 30px;
    /* background: #666; */
    display: inline-block;
  }
  .icon:first-child{
    margin-right: 10px;
  }
  input[type="text"]{
    /* margin: 0 10%; */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 78%;
    background: #fff;
  }
  .shadow{
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  }
  .hide{
    transform: translateY(-50px);
    /* opacity: 0; */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layouts/LayoutHeader.vue